export class ConsoleSuppressor {
  constructor(windowElement, console) {
    this.console = console;
    this.window = windowElement;
  }

  isWhiteListed() {
    const { host } = this.window.location;
    return host.indexOf('localhost') >= 0 || host.indexOf('stage.branch') >= 0;
  }

  isBlackListed() {
    const { host } = this.window.location;
    return host === 'dashboard-release.stage.branch.io';
  }

  hide() {
    this.console.warn = () => {};
    this.console.disableYellowBox = true;
  }

  hideWarnings() {
    if (this.isBlackListed()) {
      this.hide();
      return;
    }

    if (!this.isWhiteListed()) {
      this.hide();
    }
  }
}
